<template>
  <aside
    class="d-flex flex-column h-100 position-sticky right-0"
    style="min-width: 24rem; top: 40px"
    data-testid="news.feed"
  >
    <div v-if="editor" class="d-flex justify-content-end w-100 flex-shrink-0 mb-1">
      <IconButtonGroup>
        <a :href="getLink()" target="_blank">
          <IconButton icon-name="material-symbols:add" variant="ghost" class="news-icon-button" />
        </a>
      </IconButtonGroup>
    </div>
    <div class="overflow-y-auto custom-scrollbar px-1">
      <div class="custom-scrollbar overflow-y-auto flex-grow-1">
        <template v-for="i in items" :key="i.meta.id">
          <NewsPagePreviewCard
            :class="['border-0', {'mb-2': i.meta.id !== items[items.length - 1].meta.id}]"
            :news-item="i"
            :is-selected="i.meta.id === active"
            @update="$emit('updateItem', i)"
          />
        </template>
      </div>
    </div>
    <BootstrapPagination
      v-if="count > 1"
      class="mt-2 m-1 flex-shrink-0"
      :count="count"
      :page="Math.floor(offset / limit) + 1"
      @update:page="(value: number) => $emit('updateCursor', value)"
    />
  </aside>
</template>
<script setup lang="ts">
import config from '@/config';
defineProps<{
  active: number | null;
  editor: boolean;
  loading: boolean;
}>();
defineEmits<{
  updateCursor: [value: number];
  updateItem: [value: NewsItem];
}>();
const newsStore = useNewsStore();
const getLink = (): URL => new URL('/cms/pages/', config.CMS_ADMIN_URL);
const items = computed<NewsItem[]>(() => newsStore.newsItems);
const total = computed(() => newsStore.totalNewsItems);
// const newsIndexList = computed(() => newsStore.newsIndexList[language.value.split('-')[0]]);
const offset = computed(() => newsStore.offset);
const limit = computed(() => newsStore.limit);
const count = computed(() => Math.ceil(total.value / limit.value));
</script>
